import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // console.log("Stimulus: RemovalController connected")
  }

  remove() {
    // console.log("Stimulus: RemovalController | Function: remove")
    this.element.remove()
  }
}